import { ConfigProvider, Flex, Form, Input, Radio, Select, Space } from "antd";
import cx from "classnames";

import { useTranslation } from "react-i18next";
import styles from "./Input.module.css";

const FormRadio = ({
    label = "",
    name = "",
    placeholder = null,
    type = "text",
    size = "middle",
    onChange = () => { },
    className = "",
    subclassName = "",
    required = false,
    options = [],
    vertical = true,
    labelFontSize = "16px",
    fontWeight = "",
    direction = "horizontal",
    disabled = false
}) => {

    const handleChange = (e) => {
        const value = e;
        onChange(value);
    };

    const { t, i18n } = useTranslation();

    const layout = {
        labelCol: {
            span: 24,
        },
        wrapperCol: {
            span: 24,
        },

    }
    return (
        <ConfigProvider theme={{
            components: {
                Form: {
                    labelFontSize: labelFontSize
                },
            },
        }}>
            <Form.Item
                {...(vertical && layout)}
                label={label}
                name={name}
                required={required}
                style={{
                    fontWeight: fontWeight,
                    padding: "0px",
                    margin: "0px"
                }}
                rules={[{ required: required, message: i18n.language == 'th' ? 'กรุณากรอก ${label}' : '${label} is required' }]}
            >
                <Radio.Group
                    required
                    name={name}
                    disabled={disabled}
                    label={label}
                    placeholder={placeholder ?? label}
                    size={size}
                    onChange={handleChange}
                >
                    <Flex vertical={direction == 'vertical'}>
                        {options.map(o => {
                            return <Radio value={o.value}>{o.label}</Radio>
                        })}
                    </Flex>
                </Radio.Group>
            </Form.Item>
        </ConfigProvider>
    );
};

export default FormRadio;
